exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pannel-container {\n    position: fixed;\n    height: 100%;\n    width: 300px;\n    left: 0;\n    top: 0;\n    padding-top: 55px;\n}\n\n.flex-modifier-user-view {\n    flex-direction: column;\n    align-items: flex-end;\n}\n\n.user-page-content-container {\n    margin-bottom: 50px;\n}\n\n@media only screen and (min-width: 600px) {\n    .flex-modifier-user-view {\n        flex-direction: row;\n        align-items: inherit;\n    }\n}\n\n@media only screen and (min-width: 768px) {\n\n    .user-page-content-container {\n        margin-left: 300px;\n    }\n}", ""]);

// exports
